module.exports = __webpack_public_path__ + "img/Meng Horng Lee.45139dc2.jpg";